import { getRandomInt } from './helpers';

const getHotelData = function (id) {
  return {
    id: id,
    distanceText: '8.1 km from your search',
    title: '1 Mind is the only enlightenment, the only guarantee of courage. Peace is not one in zion, the mind, or shangri-la, but everywhere. Never develop the teacher, for you cannot study it.',
    stars: 5,
    rating: {
      value: 3.1,
      total: 174,
    },
    hotelLink: '#hotelLink',
    reserveBtnUrl: 'https://html.adagio.adyax-dev.com/first-step.html',
    coordinates: {
      lat: 52.0808361,
      lng: 23.7107032,
    },
    firstImage: {
      src: "https://medias.adagio-city.com/photos/1910_ho_00_p_346x260.jpg?twic=v1/cover=332x249",
      alt: "Aparthotel Adagio Toulouse Centre Ramblas",
      width: "332",
      height: "249"
    },
    images: [
      {
        title: '',
        src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
      },
      {
        title: '',
        src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/419/41983422.jpg',
      },
      {
        title: '',
        src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
      },
    ],
    featureImages: [
      {
        className: 'icon-ANIMALS',
        label: 'Ouvert 24H/24 7J/7 toute l’année',
      },
      {
        className: 'icon-ANIMALS',
      },
      {
        className: 'icon-ANIMALS',
        label: 'Ouvert 24H/24 7J/7 toute l’année',
      },
      {
        className: 'icon-ANIMALS',
      },
      {
        className: 'icon-ANIMALS',
      },
    ],
    oldPrice: '2276.20€',
    subPrice: 'Planeta, classis, et lumen.',
    discount: 'Tarif membre -10%',
    from: 'From',
    noFlat: 'NOS APPARTEMENTS',
    reserveTitle: 'Plus que 7 disponibles',
    demandMention: 'Forte demande!',
    subTitle: 'Altus tatas ducunt ad candidatus Altus tatas ducunt ad candidatus. Altus tatas ducunt ad candidatus. Altus tatas ducunt ad candidatus. Altus tatas ducunt ad candidatus.',
    reserveBtn: 'Book',
    reserveBtnUnavailable: 'See available dates',
    available: true,
    unavailableText: 'No appartement available for those dates',
  }
}

export default {
  brand_statement: [
    {
      image_link: '/brandingStatement/BG.svg',
      text: 'Paris, Aisne1',
      href: '?geoCode=V89320&geoType=VI',
    },
    {
      image_link: '/brandingStatement/BG.svg',
      text: 'Paris, Aisne2',
      href: '?geoCode=V89321&geoType=VII',
    },
    {
      image_link: '/brandingStatement/BG.svg',
      text: 'Paris, Aisne3',
      href: '?geoCode=V89323&geoType=VIII',
    },
  ],
  code: {
    companyName: 'Google inc.',
    companyLabel: 'Entreprise',
    loyaltyCard: '082T6VHC26453298',
    loyaltyLabel: 'Carte de fidélité',
    image_link: '/brandingStatement/BG.svg',
  },
  results: [
    {
      id: 2,
      title: '2 Mind is the only enlightenment, the only guarantee of courage. Peace is not one in zion, the mind, or shangri-la, but everywhere. Never develop the teacher, for you cannot study it.',
      stars: 1,
      rating: {
        value: 2.1,
        total: 174,
      },
      hotelLink: '#hotelLink',
      reserveBtnUrl: 'https://html.adagio.adyax-dev.com/first-step.html',
      coordinates: {
        lat: 52.0981281,
        lng: 23.7536332,
      },
      firstImage: {
        src: "https://medias.adagio-city.com/photos/1910_ho_00_p_346x260.jpg?twic=v1/cover=332x249",
        alt: "Aparthotel Adagio Toulouse Centre Ramblas",
        width: "332",
        height: "249"
      },
      images: [
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
        },
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/419/41983422.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
        },
      ],
      featureImages: [
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
      ],
      oldPrice: '2276.20€',
      subPrice: 'Planeta, classis, et lumen.',
      discount: 'Tarif membre -10%',
      noFlat: 'NOS APPARTEMENTS',
      reserveTitle: 'Plus que 7 disponibles',
      subTitle: 'Altus tatas ducunt ad candidatus.',
      reserveBtn: 'Book',
      reserveBtnUnavailable: 'See available dates',
      available: false,
      unavailableText: 'No appartement available for those dates',
    },
    {
      id: 3,
      title: '3 Mind is the only enlightenment, the only guarantee of courage. Peace is not one in zion, the mind, or shangri-la, but everywhere. Never develop the teacher, for you cannot study it.',
      stars: 3,
      rating: {
        value: 1.1,
        total: 174,
      },
      hotelLink: '#hotelLink',
      reserveBtnUrl: 'https://html.adagio.adyax-dev.com/first-step.html',
      coordinates: {
        lat: 52.0938551,
        lng: 23.7325192,
      },
      firstImage: {
        src: "https://medias.adagio-city.com/photos/1910_ho_00_p_346x260.jpg?twic=v1/cover=332x249",
        alt: "Aparthotel Adagio Toulouse Centre Ramblas",
        width: "332",
        height: "249"
      },
      images: [
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
        },
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/419/41983422.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
        },
      ],
      featureImages: [
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
        {
          className: 'icon-ANIMALS',
        },
      ],
      oldPrice: '2276.20€',
      subPrice: 'Planeta, classis, et lumen.',
      discount: 'Tarif membre -10%',
      noFlat: 'NOS APPARTEMENTS',
      reserveTitle: 'Plus que 7 disponibles',
      subTitle: 'Altus tatas ducunt ad candidatus.',
      reserveBtn: 'Book',
      reserveBtnUnavailable: 'See available dates',
      available: false,
      unavailableText: 'No appartement available for those dates',
    },
    {
      id: 4,
      title: '5 Mind is the only enlightenment, the only guarantee of courage. Peace is not one in zion, the mind, or shangri-la, but everywhere. Never develop the teacher, for you cannot study it.',
      stars: 4,
      rating: {
        value: 14.1,
        total: 174,
      },
      hotelLink: '#hotelLink',
      coordinates: {
        lat: 52.0873411,
        lng: 23.7181852,
      },
      firstImage: {
        src: "https://medias.adagio-city.com/photos/1910_ho_00_p_346x260.jpg?twic=v1/cover=332x249",
        alt: "Aparthotel Adagio Toulouse Centre Ramblas",
        width: "332",
        height: "249"
      },
      images: [
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
        },
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/419/41983422.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
        },
      ],
      featureImages: [
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
      ],
      oldPrice: '2276.20€',
      subPrice: 'Planeta, classis, et lumen.',
      discount: 'Tarif membre -10%',
      noFlat: 'NOS APPARTEMENTS',
      reserveTitle: 'Plus que 7 disponibles',
      subTitle: 'Altus tatas ducunt ad candidatus.',
      reserveBtn: 'Book',
      reserveBtnUnavailable: 'See available dates',
      available: true,
      unavailableText: 'No appartement available for those dates',
    },
    {
      id: 5,
      title: '5 Mind is the only enlightenment, the only guarantee of courage. Peace is not one in zion, the mind, or shangri-la, but everywhere. Never develop the teacher, for you cannot study it.',
      stars: 4,
      rating: {
        value: 14.1,
        total: 174,
      },
      hotelLink: '#hotelLink',
      coordinates: {
        lat: 52.0873411,
        lng: 23.7181852,
      },
      firstImage: {
        src: "https://medias.adagio-city.com/photos/1910_ho_00_p_346x260.jpg?twic=v1/cover=332x249",
        alt: "Aparthotel Adagio Toulouse Centre Ramblas",
        width: "332",
        height: "249"
      },
      images: [
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
        },
      ],
      featureImages: [
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
      ],
      oldPrice: '2276.20€',
      subPrice: 'Planeta, classis, et lumen.',
      discount: 'Tarif membre -10%',
      noFlat: 'NOS APPARTEMENTS',
      reserveTitle: 'Plus que 7 disponibles',
      subTitle: 'Altus tatas ducunt ad candidatus.',
      reserveBtn: 'Book',
      reserveBtnUnavailable: 'See available dates',
      available: true,
      unavailableText: 'No appartement available for those dates',
    },
    {
      id: 6,
      title: '6 Mind is the only enlightenment, the only guarantee of courage. Peace is not one in zion, the mind, or shangri-la, but everywhere. Never develop the teacher, for you cannot study it.',
      stars: 4,
      rating: {
        value: 14.1,
        total: 174,
      },
      coordinates: {
        lat: 52.0873411,
        lng: 23.7181852,
      },
      hotelLink: '#hotelLink',
      firstImage: {
        src: "https://medias.adagio-city.com/photos/1910_ho_00_p_346x260.jpg?twic=v1/cover=332x249",
        alt: "Aparthotel Adagio Toulouse Centre Ramblas",
        width: "332",
        height: "249"
      },
      images: [

      ],
      featureImages: [
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
      ],
      oldPrice: '2276.20€',
      subPrice: 'Planeta, classis, et lumen.',
      discount: 'Tarif membre -10%',
      noFlat: 'NOS APPARTEMENTS',
      reserveTitle: 'Plus que 7 disponibles',
      subTitle: 'Altus tatas ducunt ad candidatus.',
      reserveBtn: 'Book',
      reserveBtnUnavailable: 'See available dates',
      available: true,
      unavailableText: 'No appartement available for those dates',
    },
    {
      id: 7,
      title: '7 Mind is the only enlightenment, the only guarantee of courage. Peace is not one in zion, the mind, or shangri-la, but everywhere. Never develop the teacher, for you cannot study it.',
      stars: 4,
      rating: {
        value: 14.1,
        total: 174,
      },
      hotelLink: '#hotelLink',
      coordinates: {
        lat: 52.0873411,
        lng: 23.7181852,
      },
      firstImage: {
        src: "https://medias.adagio-city.com/photos/1910_ho_00_p_346x260.jpg?twic=v1/cover=332x249",
        alt: "Aparthotel Adagio Toulouse Centre Ramblas",
        width: "332",
        height: "249"
      },
      images: [
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/396/39659322.jpg',
        },
        {
          title: '',
          src: 'https://s-ec.bstatic.com/images/hotel/max1280x900/419/41983422.jpg',
        },
        {
          title: '',
          src: 'https://t-ec.bstatic.com/images/hotel/max1280x900/419/41983388.jpg',
        },
      ],
      featureImages: [
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
        {
          src: '/some/Wifi.jpg',
          title: 'Some title wifi',
        },
      ],
      oldPrice: '2276.20€',
      subPrice: 'Planeta, classis, et lumen.',
      discount: 'Tarif membre -10%',
      noFlat: 'NOS APPARTEMENTS',
      reserveTitle: 'Plus que 7 disponibles',
      subTitle: 'Altus tatas ducunt ad candidatus.',
      reserveBtn: 'Book',
      reserveBtnUnavailable: 'See available dates',
      available: true,
      unavailableText: 'No appartement available for those dates',
    },
  ],
  dataLayer: {
    brandcontext: 'ADAGIO',
    language: 'en',
    pagename: null,
    currencycode: 'EUR',
    userconsent: true,
    JSESSIONID: 'InQxfYZxGWiltOmLn8c-cqLVRIUcAACET8gLmpa4ATc',
    'Basket ID': '6988-3114c815-adc5-4cb9-91c6-5aa1f0d94d3c',
    'User agent': 'Mozilla 5.0 (X11; Linux x86_64) AppleWebKit 537.36 (KHTML, like Gecko) Chrome 65.0.3325.181 Safari 537.36',
    uilogged: false,
    loyaltycardtypes: [],
    hotelbrandcode: 'ADG',
    hotelbrandname: 'ADAGIO',
    hotelcode: '6988',
    hotelname: 'Aparthotel Adagio Paris Opera',
    hotelcurrencycode: 'EUR',
    hotelstarnumber: 4,
    hoteladdress: '43 Rue Caumartin 75009 PARIS',
    hotelcitycode: 'SI40',
    hotelcityname: 'PARIS',
    hotelcountrycode: 'FR',
    hotelcountryname: 'FRANCE',
    hoteltripadvisorrating: 4,
    'Reviews provider': 'TRIPADVISOR',
    searchcriteriaarrivaldate: '17-09-2018',
    searchcriterianumbernights: '1',
    searchcriteriadeparturedate: '18-09-2018',
    searchcriterianumberrooms: 1,
    searchcriterianumberadult: 1,
    searchcriterianumberchildren: 0,
    searchcriteriadestination: 'Paris, France',
  },
}
